/**
 * Servicio para gestión de asistencia del profesor
 */

import {
  AsistenciaQueryParams,
  AsistenciaResponse,
} from "../../app/profesor/asistencia/dto/asistencia.dto";
import { apiClientWeb } from "../../lib/apiClientWeb";

export const asistenciaProfesorService = {
  /**
   * Obtiene la asistencia de los alumnos del colegio del profesor
   * No necesita profesorId - usa el token JWT para identificar al profesor
   * @param params Parámetros opcionales de fecha (fechaInicio, fechaFin)
   * @returns Respuesta con la asistencia de los alumnos
   */
  getAsistencia: async (
    params?: AsistenciaQueryParams
  ): Promise<AsistenciaResponse> => {
    const queryParams: Record<string, string> = {};

    if (params?.fechaInicio) {
      queryParams.fechaInicio = params.fechaInicio;
    }

    if (params?.fechaFin) {
      queryParams.fechaFin = params.fechaFin;
    }

    const response = await apiClientWeb.get(`/api/profesor/asistencia`, {
      params: queryParams,
    });

    return response.data.data; // Backend devuelve { success, data }
  },

  actualizarAsistencia: async (payload: {
    usuarioId: number;
    fecha: string;
    actividades: string[] | null;
  }) => {
    const response = await apiClientWeb.patch(
      `/api/profesor/asistencia`,
      payload
    );

    return {
      status: response.status,
      ...response.data,
    };
  },
};
